(function (ws) {
    'use strict';

    ws.views.dashboardCarousel = ws.views.googleAnalytics.extend({
        GTM_EVENT_CATEGORY: 'store_dashboard',

        /**
         * events
         */
        events: {
            'click li .link': 'trackImageClick'
        },

        /**
         * Initialize override
         */
        initialize: function () {
            this.$carousel = this.$('.carousel');
            this.$sliders = this.$('.slide');
            this.pauseTime = this.$el.data('timeout');
            this.initialWaitTime = this.pauseTime + 3000;
            this.setCarousel();
        },

        /**
         * Set carousel
         */
        setCarousel() {
            this.$sliders.removeClass('before-carousel');
            if (this.$carousel) {
                this.$sliders.promise().done(() => {
                    this.$carousel.bxSlider({
                        controls: false,
                        auto: true,
                        autoDelay: this.initialWaitTime,
                        pause: this.pauseTime,

                        // @TODO - enable touch for tablet only
                        touchEnabled: false
                    });
                });
            }
        },

        /**
         * Sends data from Banner Image to Google Analytics;
         *
         * @param {Event} e
         */
        trackImageClick: function (e) {
            // Stop the link from navigating away
            e.preventDefault();
            const bannerLink = $(e.currentTarget).attr('href');
            const eventAction = 'banner_click';

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, eventAction, bannerLink);

            dataLayerAA.event = {};
            dataLayerAA.event.action = eventAction;
            _satellite.track('event:dashboard');

            // Navigate away after the tracking is complete
            window.location.href = bannerLink;
        }
    });

})(westcon);
